import { Component, OnInit } from "@angular/core";
import { AlertController, LoadingController, NavController, NavParams, ToastController } from "ionic-angular";
import { Globals } from "../../../../globals";
import { StaticsServices } from "../../../services/statics";
import { TranslateService } from "@ngx-translate/core";
import { ConfigurationServices } from "../../../configuration/services";
import { AIServices } from "../../../services/aiServices";
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AddonsTriggerVersionProPage } from "../../../addons/addons-trigger-version-pro/addons-trigger-version-pro";

@Component({
  selector: 'page-complements-create-dish-select',
  templateUrl: 'complements-create-dish-select.html',
})
export class ComplementsCreateDishSelectPage implements OnInit {

  section_index: any;
  section: any;
  update_state: boolean = false;
  section_uid: string;
  selected_collapse: boolean = false;
  show_list: boolean = false;
  public form: FormGroup;
  es: any;
  en: any;
  it: any;
  de: any;
  fr: any;
  ca: any;

  /**
   * Falta que al editar iniciar los platos que ya estan en la seccion que se quiere editar.
   */

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public toastCtrl: ToastController,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    public configurationService: ConfigurationServices,
    private alertCtrl: AlertController,
    public aiServices: AIServices,
    public fb: FormBuilder,
    public http: HttpClient) {
    this.configurationService.complements_selected = [];

    this.section = this.navParams.get('section');
    this.section_index = this.navParams.get('section_index');
    this.update_state = this.navParams.get('update');
    this.section_uid = this.navParams.get('uid');

    if (this.update_state) {
      this.section.complements.forEach(complement => {
        const find = this.configurationService.list_complements_array.find(x => x.UID === complement);
        if (find) {
          this.configurationService.complements_selected.push(find);
        }
      });
    }

  }

  ngOnInit() {
    // Inicializar valores
    this.es = this.section.name;
    this.en = this.section.name_en;
    this.fr = this.section.name_fr;
    this.it = this.section.name_it;
    this.de = this.section.name_de;
    this.ca = this.section.name_ca;

    // Crear FormGroup
    this.form = this.fb.group({
      name: [this.section.name],
      name_en: [this.section.name_en],
      name_fr: [this.section.name_fr],
      name_it: [this.section.name_it],
      name_de: [this.section.name_de],
      name_ca: [this.section.name_ca]
    });

    // Sincronizar cambios del formulario con el objeto section y mostrar opción de traducción
    if (this.globals.checkLimitsByLicense('dishes', 'langs')) {
      this.form.valueChanges.subscribe(values => {
        this.section.name = values.name;
        this.section.name_en = values.name_en;
        this.section.name_fr = values.name_fr;
        this.section.name_it = values.name_it;
        this.section.name_de = values.name_de;
        this.section.name_ca = values.name_ca;

        // Mostrar opción de traducción si hay contenido en el campo principal
        if (this.returnNameContent() && this.returnNameContent().trim() !== '') {
          this.show_list = true;
        } else {
          this.show_list = false;
        }
      });
    }
  }

  translateSection() {
    if (!this.globals.checkLimitsByLicense('dishes', 'langs')) {
      this.navCtrl.push(AddonsTriggerVersionProPage);
      return;
    }
    // Preguntar si quiere traducir
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-traducir-complemento'),
      message: this.translate.instant('instant-traducir-auto-complemento-message'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.translateSectionWithAI();
          }
        }
      ]
    });
    alert.present();
  }

  async translateSectionWithAI() {
    // Mostrar loader
    const loader = this.loadingCtrl.create({
      content: this.translate.instant('instant-traduciendo') || 'Traduciendo...',
      dismissOnPageChange: false
    });
    await loader.present();

    try {
      // Obtener el idioma del restaurante y el nombre del complemento
      const restaurantLang = this.globals.restaurant.lang;
      const sectionName = this.returnNameContent();

      // Definir prompts según el idioma del restaurante
      const prompts = {
        'es': {
          system: "Eres un experto traductor gastronómico. Debes traducir el nombre de un grupo de complementos a 6 idiomas: español (es), inglés (en), francés (fr), alemán (de), italiano (it) y catalán (ca). Responde únicamente con un JSON válido que contenga las traducciones con las claves: es, en, fr, de, it, ca. No añadas ningún texto adicional, solo el JSON.",
          user: `Traduce el nombre de este grupo de complementos: "${sectionName}" a los 6 idiomas mencionados. Responde solo con el JSON.`
        },
        'en': {
          system: "You are an expert gastronomic translator. You must translate a complement group name to 6 languages: Spanish (es), English (en), French (fr), German (de), Italian (it) and Catalan (ca). Respond only with a valid JSON containing the translations with keys: es, en, fr, de, it, ca. Do not add any additional text, just the JSON.",
          user: `Translate the name of this complement group: "${sectionName}" to the 6 mentioned languages. Respond only with the JSON.`
        },
        'fr': {
          system: "Vous êtes un traducteur gastronomique expert. Vous devez traduire le nom d'un groupe de compléments en 6 langues : espagnol (es), anglais (en), français (fr), allemand (de), italien (it) et catalan (ca). Répondez uniquement avec un JSON valide contenant les traductions avec les clés : es, en, fr, de, it, ca. N'ajoutez aucun texte supplémentaire, juste le JSON.",
          user: `Traduisez le nom de ce groupe de compléments : "${sectionName}" dans les 6 langues mentionnées. Répondez uniquement avec le JSON.`
        },
        'de': {
          system: "Sie sind ein Experte für gastronomische Übersetzungen. Sie müssen den Namen einer Ergänzungsgruppe in 6 Sprachen übersetzen: Spanisch (es), Englisch (en), Französisch (fr), Deutsch (de), Italienisch (it) und Katalanisch (ca). Antworten Sie nur mit einem gültigen JSON, das die Übersetzungen mit den Schlüsseln enthält: es, en, fr, de, it, ca. Fügen Sie keinen zusätzlichen Text hinzu, nur das JSON.",
          user: `Übersetzen Sie den Namen dieser Ergänzungsgruppe: "${sectionName}" in die 6 genannten Sprachen. Antworten Sie nur mit dem JSON.`
        },
        'it': {
          system: "Sei un traduttore gastronomico esperto. Devi tradurre il nome di un gruppo di complementi in 6 lingue: spagnolo (es), inglese (en), francese (fr), tedesco (de), italiano (it) e catalano (ca). Rispondi solo con un JSON valido contenente le traduzioni con le chiavi: es, en, fr, de, it, ca. Non aggiungere alcun testo aggiuntivo, solo il JSON.",
          user: `Traduci il nome di questo gruppo di complementi: "${sectionName}" nelle 6 lingue menzionate. Rispondi solo con il JSON.`
        },
        'ca': {
          system: "Ets un traductor gastronòmic expert. Has de traduir el nom d'un grup de complements a 6 idiomes: espanyol (es), anglès (en), francès (fr), alemany (de), italià (it) i català (ca). Respon únicament amb un JSON vàlid que contingui les traduccions amb les claus: es, en, fr, de, it, ca. No afegeixis cap text addicional, només el JSON.",
          user: `Traduïu el nom d'aquest grup de complements: "${sectionName}" als 6 idiomes esmentats. Respon només amb el JSON.`
        }
      };

      // Obtener el prompt correspondiente al idioma del restaurante
      const prompt = prompts[restaurantLang] || prompts['en']; // Fallback a inglés si no existe el idioma

      const messages = [
        {
          "role": "system",
          "content": prompt.system
        },
        {
          "role": "user",
          "content": prompt.user
        }
      ];

      // Configurar el formato de respuesta JSON
      const response_format = { "type": "json_object" };

      // Llamar a DeepSeek
      const response = await this.aiServices.deepseekOpenAIGenerateText(response_format, messages);

      // Procesar la respuesta
      if (response && response['choices'] && response['choices'][0] && response['choices'][0]['message']) {
        const content = response['choices'][0]['message']['content'];
        const translations = JSON.parse(content);

        // Aplicar capitalización y asignar valores
        this.es = translations['es'][0].toUpperCase() + translations['es'].substring(1) || '';
        this.en = translations['en'][0].toUpperCase() + translations['en'].substring(1) || '';
        this.fr = translations['fr'][0].toUpperCase() + translations['fr'].substring(1) || '';
        this.de = translations['de'][0].toUpperCase() + translations['de'].substring(1) || '';
        this.it = translations['it'][0].toUpperCase() + translations['it'].substring(1) || '';
        this.ca = translations['ca'][0].toUpperCase() + translations['ca'].substring(1) || '';

        // Actualizar el formulario
        this.form.patchValue({
          name: this.es,
          name_en: this.en,
          name_fr: this.fr,
          name_it: this.it,
          name_de: this.de,
          name_ca: this.ca
        });

        // Actualizar el objeto section
        this.section.name = this.es;
        this.section.name_en = this.en;
        this.section.name_fr = this.fr;
        this.section.name_it = this.it;
        this.section.name_de = this.de;
        this.section.name_ca = this.ca;

        // Limpiar
        this.show_list = false;
      }

      // Ocultar loader al completar exitosamente
      loader.dismiss();

    } catch (error) {
      // Ocultar loader en caso de error
      loader.dismiss();

      console.error('Error al traducir con DeepSeek:', error);
      // Mostrar mensaje de error al usuario
      let alert = this.alertCtrl.create({
        title: this.translate.instant('general-error'),
        message: this.translate.instant('instant-traducir-error') || 'Error al traducir el complemento',
        buttons: ['OK']
      });
      alert.present();
    }
  }

  returnName() {
    switch (this.globals.restaurant.lang) {
      case 'es': {
        return 'name';
      }
      case 'en': {
        return 'name_en';
      }
      case 'fr': {
        return 'name_fr';
      }
      case 'de': {
        return 'name_de';
      }
      case 'it': {
        return 'name_it';
      }
      case 'ca': {
        return 'name_ca';
      }
    }
  }

  returnNameContent() {
    switch (this.globals.restaurant.lang) {
      case 'es': {
        return this.form.get('name').value;
      }
      case 'en': {
        return this.form.get('name_en').value;
      }
      case 'fr': {
        return this.form.get('name_fr').value;
      }
      case 'de': {
        return this.form.get('name_de').value;
      }
      case 'it': {
        return this.form.get('name_it').value;
      }
      case 'ca': {
        return this.form.get('name_ca').value;
      }
    }
  }

  ngOnDestroy() {
    this.configurationService.complements_selected = [];
    this.configurationService.complements_array_filtered = [...this.configurationService.complements_array_tmp];
    this.configurationService.complements_searchbar_text = '';
  }

  updateFirestore(section) {
    if (this.update_state) {
      this.configurationService.afs.collection('complements_groups').doc(this.section_uid).update(section);
      this.staticsServices.changeStateStaticWait(true);
    } else {
      this.configurationService.afs.collection('complements_groups').add(section).then(docRef => {
        section.UID = docRef.id;
      });
    }
    this.configurationService.complements_group_array_filtered.push(section);
    this.configurationService.complements_group_array.push(section);
    this.configurationService.complements_groups_selected.push(section);
  }

  update() {
    // Validar que el nombre esté en el idioma seleccionado
    let nameInSelectedLang = '';
    switch (this.globals.restaurant.lang) {
      case 'es':
        nameInSelectedLang = this.section.name;
        break;
      case 'ca':
        nameInSelectedLang = this.section.name_ca;
        break;
      case 'en':
        nameInSelectedLang = this.section.name_en;
        break;
      case 'fr':
        nameInSelectedLang = this.section.name_fr;
        break;
      case 'de':
        nameInSelectedLang = this.section.name_de;
        break;
      case 'it':
        nameInSelectedLang = this.section.name_it;
        break;
    }

    if (!nameInSelectedLang) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-introduce-nombre-idioma') + ' ' + this.globals.getLanguageName(this.globals.restaurant.lang),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
      return;
    }

    const elements = this.configurationService.complements_selected.map(element => { return element.UID; });
    const min = Number(this.section.min_elements || 0);
    const max = Number(this.section.max_elements || 0);

    // Validación: max no puede ser menor que min
    if (min > max) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-error-maximo-menor-minimo'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
      return;
    }

    // Validación: si es required y select_multi, mínimo debe ser al menos 1
    if (this.section.required && this.section.select_multi && min < 1) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-error-minimo-obligatorio'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
      return;
    }

    // Obtener el nombre en el idioma principal
    const mainLang = this.globals.restaurant.lang;
    const mainName = nameInSelectedLang;

    // En la actualización, mantenemos los nombres específicos de cada idioma
    const update_section = {
      UID_RESTAURANT: this.globals.restaurant_uid,
      name: mainLang === 'es' ? mainName : (this.section.name || mainName),
      name_ca: mainLang === 'ca' ? mainName : (this.section.name_ca || mainName),
      name_en: mainLang === 'en' ? mainName : (this.section.name_en || mainName),
      name_fr: mainLang === 'fr' ? mainName : (this.section.name_fr || mainName),
      name_de: mainLang === 'de' ? mainName : (this.section.name_de || mainName),
      name_it: mainLang === 'it' ? mainName : (this.section.name_it || mainName),
      required: this.section.required || false,
      required_tk: this.section.required_tk || false,
      select_multi: this.section.select_multi || false,
      cost_extra: this.section.cost_extra || false,
      quit_elements: this.section.quit_elements || false,
      complements: elements,
      min_elements: min,
      max_elements: max
    }

    this.updateFirestore(update_section);
    this.navCtrl.pop();
  }

  deleteSection() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-eliminar-grupo'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            //delete
            delete this.configurationService.complements_group_array[this.section_index];
            //reordenar
            var obj_help = {};
            var i = 0;
            for (let item of this.globals.objectToArray(this.configurationService.complements_group_array)) {
              obj_help[i] = item;
              i++;
            }
            this.configurationService.complements_group_array = obj_help;

            this.configurationService.afs.collection('complements_groups').doc(this.section_uid).delete();
            //statics
            this.staticsServices.changeStateStaticWait(true);
            this.staticsServices.addDeleteStaticToQueue(this.section_uid, 'delete_variation_update');

            this.navCtrl.pop();
          }
        }
      ]
    });
    alert.present();
  }

  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/complements/complements-partial-select/complements-create-dish-select/complements-create-dish-select.ts